import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  companySettingForm: {
    "& h4": {
      marginLeft: 24
    },
    [theme.breakpoints.up("lg")]: {
      padding: "40px 100px",
      "& .MuiGrid-item": {
        padding: "12px 40px"
      }
    },
    [theme.breakpoints.down("lg")]: {
      padding: "40px"
    },
    [theme.breakpoints.down("md")]: {
      padding: 24
    }
  },
  removeCustomSpacing: {
    "& .MuiGrid-item": {
      padding: "12px"
    }
  },
  uploadLogo: {
    borderRadius: 4,
    border: 'solid 1px #EEECEC',
    height: 160,
    "& .upload-btn-group": {
      top: 24
    }
  },
  displayUrl: {
    position: "relative",
    // background: '#FAFAFA',
    borderRadius: 4,
    border: 'solid 1px #EEECEC',
    height: 160,
    "& .upload-btn-group": {
      top: 24
    }
  },
  logoDisplay: {
    height: '100%',
    width: '100%',
    objectFit: 'contain'
  },
  resetSpacing: {
    "& .MuiGrid-item": {
      padding: "8px"
    }
  },
  resetSpacingLogo: {
    "& .MuiGrid-item": {
      padding: "24px 24px 3px"
    }
  },
  resetSpacingSocialMedia: {
    padding: "0 40px !important"
  },
  formGroup: {
    "& .MuiFormControl-fullWidth": {
      marginBottom: 24
    }
  },
  socialMedia: {
    "& .MuiInputBase-fullWidth": {
      "& svg": {
        color: '#A0A0A0',
        width: 20
      }
    }
  },
  textArea: {
    "& textarea": {
      height: 160,
      boxSizing: 'border-box'
    }
  },
  disableLogo: {
    "& .upload-btn-group": {
      display: 'none'
    }
  },
  imgWrapper: {
    background: '#3D4C53'
  }
}));
export default useStyles;
